import React from "react";
import { FormattedMessage } from 'react-intl';

const SUCCESS = "success"
const FAIL = "fail"
const styles = {
  textStyle: {
    fontSize: 18,
    weight: 800
  },
  successStyle: {
    color: "#702f8a"
  },
  failStyle: {
    color: "#535353"
  }
}

export const Text = (props) => {

  if (props.status === SUCCESS) {
    return (
      <div className="text" align="center">
        <h2 className="title-1"><FormattedMessage id="payment.success.title" /></h2>
        <p style={{...styles.textStyle, ...styles.successStyle}}>
        <FormattedMessage id={props.successMessage} />
        </p>
      </div>
    )
  } else if (props.status === FAIL) {
    return (
      <div className="text" align="center">
        <h2 className="title-1"><FormattedMessage id="payment.error.title" /></h2>
        <p style={{...styles.textStyle, ...styles.failStyle}}>
        <FormattedMessage id={props.errorMessage ? props.errorMessage : "unexpected.error"} />
        </p>
      </div>
    )
  } else {
    return <div></div>
  }
}

export const RedirectLink = (props) => {
  return (
    <div className="text" align="center">
      <FormattedMessage id="validation.redirectUrl" />
      <FormattedMessage
        id="{link}"
        defaultMessage="{link}."
        values={{
            link: <a href={props.redirectUrl}>
                <FormattedMessage
                    id="validation.redirectUrl.here"
                />
            </a>
        }}
    />
    </div>
  )
}
